import {
  CategoryNameSchemasType,
  ColumnDataType,
  formatDate,
  formatNumber,
  TextEllipsis,
} from '@atlas-frontend/sdk';

export interface InputDataCellProps {
  dataType?: ColumnDataType | null;
  labels?: CategoryNameSchemasType | null;
  value: string | number | null;
}

export function InputDataCell({ labels, dataType, value }: InputDataCellProps) {
  const valueName = value != null ? labels?.[value]?.name : undefined;

  if (valueName) {
    return (
      <TextEllipsis tooltip={`${value} - ${valueName}`} renderTooltip="always">
        {value}
      </TextEllipsis>
    );
  }

  let formattedValue = value;
  if (typeof value === 'number') {
    formattedValue = formatNumber(value);
  } else if (dataType === 'DATE') {
    formattedValue = formatDate(value) ?? '';
  }

  return <TextEllipsis>{formattedValue}</TextEllipsis>;
}
